module.exports = __webpack_public_path__ + "img/16f3034.jpg";